import { useCallback } from 'react';
import { useStore } from 'react-admin'
import { Slider, Typography } from '@mui/material'


export const MapDataOpacitySlider = () => {
  const [value, setValue] = useStore<number>('map.opacity', 0.5);

  const handleChange = useCallback((_: Event, value: number | number[]) => {
    setValue(value as number);
  }, [setValue]);
  
  const valuetext = (value: number) => `${value}%`;

  return (
    <>
      <Typography variant="h6" id="data-map-opacity-slider" gutterBottom>
        {'Data Map Opacity'}
      </Typography>
      <Slider
        aria-labelledby="data-map-opacity-slider"
        defaultValue={0.5}
        getAriaValueText={valuetext}
        step={0.05}
        marks
        min={0.1}
        max={1.0}
        onChange={handleChange}
        value={value}
        valueLabelDisplay="auto"
      />
    </>
  )
};
